import { createAction } from 'redux-actions';

import {
  LOAD_LIST_ONLINE_SERVICE,
  LOAD_LIST_ONLINE_SERVICE_ERROR,
  LOAD_LIST_ONLINE_SERVICE_SUCCESS,
} from './type';

export const loadListOnlineServiceAction = createAction(
  LOAD_LIST_ONLINE_SERVICE,
);
export const loadListOnlineServiceErrorAction = createAction(
  LOAD_LIST_ONLINE_SERVICE_ERROR,
);
export const loadListOnlineServiceSuccessAction = createAction(
  LOAD_LIST_ONLINE_SERVICE_SUCCESS,
);
